import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  empList: [],
  isEmpLoading: true,
};

const empSlice = createSlice({
  name: "emp",
  initialState,
  reducers: {
    setEmpData(state, action) {
      state.empList = action.payload;
      state.isEmpLoading = false;
    },
    removeEmpData(state, action) {
      state.empList = [];
      state.isEmpLoading = true;
    },
  },
});
export const { setEmpData, removeEmpData } = empSlice.actions;
export default empSlice.reducer;
